import { POST } from '@/api'

export default {
  namespaced: true,
  state: {
    list: {},
    busy: false,
  },
  mutations: {
    set(state, data) {
      state.list = data
    },
    busy(state, busy) {
      state.busy = busy
    },
  },
  getters: {},
  actions: {
    async get({ rootState, commit, state }) {
      if (state.busy) return false
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/v2/sync/list', {
        store_id: rootState.stores.current.store.id,
      })
      if (status === 200) {
        commit('set', data)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
